module.exports = __webpack_public_path__ + "static/media/NegotiationBuyRequest.9909f217.png";